/* src/app/components/pages/faq/faq.component.scss */
mat-expansion-panel-header,
p {
  font-family: "IBM Plex Sans", sans-serif !important;
}
.br {
  border-radius: 23px !important;
}
::ng-deep .mat-accordion .mat-expansion-panel-spacing {
  margin: 0px !important;
}
.faq input {
  font-size: 14px !important;
}
/*# sourceMappingURL=faq.component.css.map */
